import { NodePosition } from './dynamic-workflow-layout';

export interface WorkflowCamera {
  panX: number;
  panY: number;
  scale: number;
}

/** Converts a browser position into the graph's unbounded world coordinates. */
export function screenToWorld(
  screen: NodePosition,
  viewportOrigin: NodePosition,
  camera: WorkflowCamera,
): NodePosition {
  return {
    x: (screen.x - viewportOrigin.x - camera.panX) / camera.scale,
    y: (screen.y - viewportOrigin.y - camera.panY) / camera.scale,
  };
}

/** Converts a graph position back into browser coordinates. */
export function worldToScreen(
  world: NodePosition,
  viewportOrigin: NodePosition,
  camera: WorkflowCamera,
): NodePosition {
  return {
    x: viewportOrigin.x + camera.panX + world.x * camera.scale,
    y: viewportOrigin.y + camera.panY + world.y * camera.scale,
  };
}

/** Moves the camera while keeping one world point fixed under the cursor. */
export function zoomCameraAt(
  camera: WorkflowCamera,
  nextScale: number,
  anchor: NodePosition,
  viewportOrigin: NodePosition,
): WorkflowCamera {
  const world = screenToWorld(anchor, viewportOrigin, camera);
  return {
    scale: nextScale,
    panX: anchor.x - viewportOrigin.x - world.x * nextScale,
    panY: anchor.y - viewportOrigin.y - world.y * nextScale,
  };
}
